"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 2C9.3 2 6.8 3.1 4.9 5 3 6.9 2 9.5 2 12.2c0 5.4 4.4 9.8 9.8 9.8h.2c5.6-.1 10-4.6 10-10.2C22 6.4 17.6 2 12.2 2H12Zm-.8 5.58c0-.5.4-.8.8-.8.5 0 .8.4.8.8v5c0 .5-.4.8-.8.8-.5 0-.8-.3-.8-.8v-5Zm.8 9.65a1.3 1.3 0 1 1 0-2.6 1.3 1.3 0 0 1 0 2.6Z"
})), "0 0 24 24", "AlertCircle");
exports.default = _default;